// import { useState } from 'react';
import { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { LOGOS } from '../../config/logos';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  // const [openMenu, setOpenMenu] = useState<string | null>(null);
  // const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // const handleMouseEnter = (menu: string) => {
  //   if (window.innerWidth >= 1024) {
  //     setOpenMenu(menu);
  //   }
  // };

  // const handleMouseLeave = () => {
  //   if (window.innerWidth >= 1024) {
  //     setOpenMenu(null);
  //   }
  // };

  // const toggleMobileSubmenu = (menu: string) => {
  //   setOpenMenu(openMenu === menu ? null : menu);
  // };

  return (
    <div>
      {/* <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-lg' : 'bg-white'
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16 sm:h-20 lg:h-24">
            <Link to="/" className="flex items-center space-x-3 group">
              <img 
                src={LOGOS.portail} 
                alt="Fred et Poppée" 
                className="h-16 w-auto transition-transform duration-300 group-hover:scale-105"
              />
            </Link>

            

            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden z-50 p-2 rounded-lg hover:bg-gray-100 transition-colors"
              aria-label="Menu"
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl sm:text-3xl`} style={{ color: '#14B8A6' }}></i>
            </button>


            <div className="hidden lg:flex items-center space-x-2">
              <Link
                to="/"
                className="px-3 xl:px-5 py-2.5 text-gray-700 hover:text-[#14B8A6] font-medium transition-colors duration-200 whitespace-nowrap text-sm xl:text-[15px]"
              >
                Accueil
              </Link>


              <div
                className="relative"
                onMouseEnter={() => handleMouseEnter('etablissement')}
                onMouseLeave={handleMouseLeave}
              >
                <button className="px-3 xl:px-5 py-2.5 text-gray-700 hover:text-[#14B8A6] font-medium transition-colors duration-200 whitespace-nowrap flex items-center space-x-1 text-sm xl:text-[15px]">
                  <span>Établissement</span>
                  <i className="ri-arrow-down-s-line text-xl"></i>
                </button>
                {openMenu === 'etablissement' && (
                  <div 
                    className="absolute top-full left-0 mt-0 bg-white shadow-xl rounded-xl py-3 min-w-[240px] border border-gray-100"
                    onMouseEnter={() => handleMouseEnter('etablissement')}
                    onMouseLeave={handleMouseLeave}
                  >
                    <a
                      href="/maternelle-primaire"
                      className="block px-6 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] transition-colors duration-200 text-sm xl:text-[15px]"
                    >
                      Maternelle & Primaire
                    </a>
                    <a
                      href="/institut"
                      className="block px-6 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] transition-colors duration-200 text-sm xl:text-[15px]"
                    >
                      Institut
                    </a>
                    <a
                      href="/lycee-francais"
                      className="block px-6 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] transition-colors duration-200 text-sm xl:text-[15px]"
                    >
                      Lycée Français
                    </a>
                    <a
                      href="/lycee-ivoirien"
                      className="block px-6 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] transition-colors duration-200 text-sm xl:text-[15px]"
                    >
                      Lycée Ivoirien
                    </a>
                  </div>
                )}
              </div>


              <div
                className="relative"
                onMouseEnter={() => handleMouseEnter('structures')}
                onMouseLeave={handleMouseLeave}
              >
                <button className="px-3 xl:px-5 py-2.5 text-gray-700 hover:text-[#14B8A6] font-medium transition-colors duration-200 whitespace-nowrap flex items-center space-x-1 text-sm xl:text-[15px]">
                  <span>Structures</span>
                  <i className="ri-arrow-down-s-line text-xl"></i>
                </button>
                {openMenu === 'structures' && (
                  <div 
                    className="absolute top-full left-0 mt-0 bg-white shadow-xl rounded-xl py-3 min-w-[220px] border border-gray-100"
                    onMouseEnter={() => handleMouseEnter('structures')}
                    onMouseLeave={handleMouseLeave}
                  >
                    <Link
                      to="/structures/restaurant"
                      className="block px-6 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] transition-colors duration-200 text-sm xl:text-[15px]"
                    >
                      Restaurant
                    </Link>
                    <Link
                      to="/structures/transport"
                      className="block px-6 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] transition-colors duration-200 text-sm xl:text-[15px]"
                    >
                      Transport
                    </Link>
                    <Link
                      to="/structures/cdi"
                      className="block px-6 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] transition-colors duration-200 text-sm xl:text-[15px]"
                    >
                      CDI
                    </Link>
                  </div>
                )}
              </div>


              <div
                className="relative"
                onMouseEnter={() => handleMouseEnter('inscription')}
                onMouseLeave={handleMouseLeave}
              >
                <button className="px-3 xl:px-5 py-2.5 text-gray-700 hover:text-[#14B8A6] font-medium transition-colors duration-200 whitespace-nowrap flex items-center space-x-1 text-sm xl:text-[15px]">
                  <span>Inscription</span>
                  <i className="ri-arrow-down-s-line text-xl"></i>
                </button>
                {openMenu === 'inscription' && (
                  <div 
                    className="absolute top-full left-0 mt-0 bg-white shadow-xl rounded-xl py-3 min-w-[220px] border border-gray-100"
                    onMouseEnter={() => handleMouseEnter('inscription')}
                    onMouseLeave={handleMouseLeave}
                  >
                    <Link
                      to="/inscription/frais"
                      className="block px-6 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] transition-colors duration-200 text-sm xl:text-[15px]"
                    >
                      Frais de Scolarité
                    </Link>
                    <Link
                      to="/inscription/fourniture"
                      className="block px-6 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] transition-colors duration-200 text-sm xl:text-[15px]"
                    >
                      Fournitures
                    </Link>
                  </div>
                )}
              </div>


              <div
                className="relative"
                onMouseEnter={() => handleMouseEnter('infos')}
                onMouseLeave={handleMouseLeave}
              >
                <button className="px-3 xl:px-5 py-2.5 text-gray-700 hover:text-[#14B8A6] font-medium transition-colors duration-200 whitespace-nowrap flex items-center space-x-1 text-sm xl:text-[15px]">
                  <span>Infos Pratiques</span>
                  <i className="ri-arrow-down-s-line text-xl"></i>
                </button>
                {openMenu === 'infos' && (
                  <div 
                    className="absolute top-full left-0 mt-0 bg-white shadow-xl rounded-xl py-3 min-w-[240px] border border-gray-100"
                    onMouseEnter={() => handleMouseEnter('infos')}
                    onMouseLeave={handleMouseLeave}
                  >
                    <Link
                      to="/infos-pratiques/calendrier"
                      className="block px-6 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] transition-colors duration-200 text-sm xl:text-[15px]"
                    >
                      Calendrier Scolaire
                    </Link>
                    <Link
                      to="/infos-pratiques/association-sportive"
                      className="block px-6 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] transition-colors duration-200 text-sm xl:text-[15px]"
                    >
                      Association Sportive
                    </Link>
                    <Link
                      to="/infos-pratiques/activite-extra"
                      className="block px-6 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] transition-colors duration-200 text-sm xl:text-[15px]"
                    >
                      Activités Extrascolaires
                    </Link>
                  </div>
                )}
              </div>

              
              <div
                className="relative"
                onMouseEnter={() => handleMouseEnter('parcours')}
                onMouseLeave={handleMouseLeave}
              >
                <button className="px-3 xl:px-5 py-2.5 text-gray-700 hover:text-[#14B8A6] font-medium transition-colors duration-200 whitespace-nowrap flex items-center space-x-1 text-sm xl:text-[15px]">
                  <span>Parcours Élèves</span>
                  <i className="ri-arrow-down-s-line text-xl"></i>
                </button>
                {openMenu === 'parcours' && (
                  <div 
                    className="absolute top-full left-0 mt-0 bg-white shadow-xl rounded-xl py-3 min-w-[220px] border border-gray-100"
                    onMouseEnter={() => handleMouseEnter('parcours')}
                    onMouseLeave={handleMouseLeave}
                  >
                    <Link
                      to="/parcours/college"
                      className="block px-6 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] transition-colors duration-200 text-sm xl:text-[15px]"
                    >
                      Collège
                    </Link>
                    <Link
                      to="/parcours/lycee"
                      className="block px-6 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] transition-colors duration-200 text-sm xl:text-[15px]"
                    >
                      Lycée
                    </Link>
                    <Link
                      to="/parcours/orientation"
                      className="block px-6 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] transition-colors duration-200 text-sm xl:text-[15px]"
                    >
                      Orientation
                    </Link>
                  </div>
                )}
              </div>

              <div
                className="relative"
                onMouseEnter={() => handleMouseEnter('actualites')}
                onMouseLeave={handleMouseLeave}
              >
                <button className="px-3 xl:px-5 py-2.5 text-gray-700 hover:text-[#14B8A6] font-medium transition-colors duration-200 whitespace-nowrap flex items-center space-x-1 text-sm xl:text-[15px]">
                  <span>Actualités</span>
                  <i className="ri-arrow-down-s-line text-xl"></i>
                </button>
                {openMenu === 'actualites' && (
                  <div 
                    className="absolute top-full left-0 mt-0 bg-white shadow-xl rounded-xl py-3 min-w-[220px] border border-gray-100"
                    onMouseEnter={() => handleMouseEnter('actualites')}
                    onMouseLeave={handleMouseLeave}
                  >
                    <Link
                      to="/actualites/evenements"
                      className="block px-6 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] transition-colors duration-200 text-sm xl:text-[15px]"
                    >
                      Événements
                    </Link>
                    <Link
                      to="/actualites/projets"
                      className="block px-6 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] transition-colors duration-200 text-sm xl:text-[15px]"
                    >
                      Projets
                    </Link>
                    <Link
                      to="/actualites/galerie"
                      className="block px-6 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] transition-colors duration-200 text-sm xl:text-[15px]"
                    >
                      Galerie
                    </Link>
                  </div>
                )}
              </div>

              <div
                className="relative"
                onMouseEnter={() => handleMouseEnter('outils')}
                onMouseLeave={handleMouseLeave}
              >
                <button className="px-3 xl:px-5 py-2.5 text-gray-700 hover:text-[#14B8A6] font-medium transition-colors duration-200 whitespace-nowrap flex items-center space-x-1 text-sm xl:text-[15px]">
                  <span>Outils</span>
                  <i className="ri-arrow-down-s-line text-xl"></i>
                </button>
                {openMenu === 'outils' && (
                  <div 
                    className="absolute top-full left-0 mt-0 bg-white shadow-xl rounded-xl py-3 min-w-[200px] border border-gray-100"
                    onMouseEnter={() => handleMouseEnter('outils')}
                    onMouseLeave={handleMouseLeave}
                  >
                    <Link
                      to="/outils/esidoc"
                      className="block px-6 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] transition-colors duration-200 text-sm xl:text-[15px]"
                    >
                      Esidoc
                    </Link>
                    <Link
                      to="/outils/pronote"
                      className="block px-6 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] transition-colors duration-200 text-sm xl:text-[15px]"
                    >
                      Pronote
                    </Link>
                  </div>
                )}
              </div>

              <Link
                to="/contact"
                className="px-3 xl:px-5 py-2.5 text-gray-700 hover:text-[#14B8A6] font-medium transition-colors duration-200 whitespace-nowrap text-sm xl:text-[15px]"
              >
                Contact
              </Link>

            
            </div>
          </div>
        </div>



        <div
          className={`lg:hidden fixed inset-0 bg-white z-40 transition-transform duration-300 ${
            mobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
          }`}
          style={{ top: '64px' }}
        >
          <div className="h-full overflow-y-auto px-4 py-6">
            <div className="space-y-2">

              <Link
                to="/"
                onClick={() => setMobileMenuOpen(false)}
                className="block px-4 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] rounded-lg font-medium transition-colors"
              >
                Accueil
              </Link>

              
              <div>
                <button
                  onClick={() => toggleMobileSubmenu('etablissement')}
                  className="w-full flex items-center justify-between px-4 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] rounded-lg font-medium transition-colors"
                >
                  <span>Établissement</span>
                  <i className={`ri-arrow-${openMenu === 'etablissement' ? 'up' : 'down'}-s-line text-xl`}></i>
                </button>
                {openMenu === 'etablissement' && (
                  <div className="ml-4 mt-2 space-y-1">
                    <Link
                      to="/maternelle-primaire"
                      onClick={() => setMobileMenuOpen(false)}
                      className="block px-4 py-2 text-gray-600 hover:text-[#14B8A6] transition-colors"
                    >
                      Maternelle & Primaire
                    </Link>
                    <Link
                      to="/institut"
                      onClick={() => setMobileMenuOpen(false)}
                      className="block px-4 py-2 text-gray-600 hover:text-[#14B8A6] transition-colors"
                    >
                      Institut
                    </Link>
                    <Link
                      to="/lycee-francais"
                      onClick={() => setMobileMenuOpen(false)}
                      className="block px-4 py-2 text-gray-600 hover:text-[#14B8A6] transition-colors"
                    >
                      Lycée Français
                    </Link>
                    <Link
                      to="/lycee-ivoirien"
                      onClick={() => setMobileMenuOpen(false)}
                      className="block px-4 py-2 text-gray-600 hover:text-[#14B8A6] transition-colors"
                    >
                      Lycée Ivoirien
                    </Link>
                  </div>
                )}
              </div>

              
              <div>
                <button
                  onClick={() => toggleMobileSubmenu('structures')}
                  className="w-full flex items-center justify-between px-4 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] rounded-lg font-medium transition-colors"
                >
                  <span>Structures</span>
                  <i className={`ri-arrow-${openMenu === 'structures' ? 'up' : 'down'}-s-line text-xl`}></i>
                </button>
                {openMenu === 'structures' && (
                  <div className="ml-4 mt-2 space-y-1">
                    <Link
                      to="/structures/restaurant"
                      onClick={() => setMobileMenuOpen(false)}
                      className="block px-4 py-2 text-gray-600 hover:text-[#14B8A6] transition-colors"
                    >
                      Restaurant
                    </Link>
                    <Link
                      to="/structures/transport"
                      onClick={() => setMobileMenuOpen(false)}
                      className="block px-4 py-2 text-gray-600 hover:text-[#14B8A6] transition-colors"
                    >
                      Transport
                    </Link>
                    <Link
                      to="/structures/cdi"
                      onClick={() => setMobileMenuOpen(false)}
                      className="block px-4 py-2 text-gray-600 hover:text-[#14B8A6] transition-colors"
                    >
                      CDI
                    </Link>
                  </div>
                )}
              </div>


              <div>
                <button
                  onClick={() => toggleMobileSubmenu('inscription')}
                  className="w-full flex items-center justify-between px-4 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] rounded-lg font-medium transition-colors"
                >
                  <span>Inscription</span>
                  <i className={`ri-arrow-${openMenu === 'inscription' ? 'up' : 'down'}-s-line text-xl`}></i>
                </button>
                {openMenu === 'inscription' && (
                  <div className="ml-4 mt-2 space-y-1">
                    <Link
                      to="/inscription/frais"
                      onClick={() => setMobileMenuOpen(false)}
                      className="block px-4 py-2 text-gray-600 hover:text-[#14B8A6] transition-colors"
                    >
                      Frais de Scolarité
                    </Link>
                    <Link
                      to="/inscription/fourniture"
                      onClick={() => setMobileMenuOpen(false)}
                      className="block px-4 py-2 text-gray-600 hover:text-[#14B8A6] transition-colors"
                    >
                      Fournitures
                    </Link>
                  </div>
                )}
              </div>

              
              <div>
                <button
                  onClick={() => toggleMobileSubmenu('infos')}
                  className="w-full flex items-center justify-between px-4 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] rounded-lg font-medium transition-colors"
                >
                  <span>Infos Pratiques</span>
                  <i className={`ri-arrow-${openMenu === 'infos' ? 'up' : 'down'}-s-line text-xl`}></i>
                </button>
                {openMenu === 'infos' && (
                  <div className="ml-4 mt-2 space-y-1">
                    <Link
                      to="/infos-pratiques/calendrier"
                      onClick={() => setMobileMenuOpen(false)}
                      className="block px-4 py-2 text-gray-600 hover:text-[#14B8A6] transition-colors"
                    >
                      Calendrier Scolaire
                    </Link>
                    <Link
                      to="/infos-pratiques/association-sportive"
                      onClick={() => setMobileMenuOpen(false)}
                      className="block px-4 py-2 text-gray-600 hover:text-[#14B8A6] transition-colors"
                    >
                      Association Sportive
                    </Link>
                    <Link
                      to="/infos-pratiques/activite-extra"
                      onClick={() => setMobileMenuOpen(false)}
                      className="block px-4 py-2 text-gray-600 hover:text-[#14B8A6] transition-colors"
                    >
                      Activités Extrascolaires
                    </Link>
                  </div>
                )}
              </div>

              
              <div>
                <button
                  onClick={() => toggleMobileSubmenu('parcours')}
                  className="w-full flex items-center justify-between px-4 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] rounded-lg font-medium transition-colors"
                >
                  <span>Parcours Élèves</span>
                  <i className={`ri-arrow-${openMenu === 'parcours' ? 'up' : 'down'}-s-line text-xl`}></i>
                </button>
                {openMenu === 'parcours' && (
                  <div className="ml-4 mt-2 space-y-1">
                    <Link
                      to="/parcours/college"
                      onClick={() => setMobileMenuOpen(false)}
                      className="block px-4 py-2 text-gray-600 hover:text-[#14B8A6] transition-colors"
                    >
                      Collège
                    </Link>
                    <Link
                      to="/parcours/lycee"
                      onClick={() => setMobileMenuOpen(false)}
                      className="block px-4 py-2 text-gray-600 hover:text-[#14B8A6] transition-colors"
                    >
                      Lycée
                    </Link>
                    <Link
                      to="/parcours/orientation"
                      onClick={() => setMobileMenuOpen(false)}
                      className="block px-4 py-2 text-gray-600 hover:text-[#14B8A6] transition-colors"
                    >
                      Orientation
                    </Link>
                  </div>
                )}
              </div>

              
              <div>
                <button
                  onClick={() => toggleMobileSubmenu('actualites')}
                  className="w-full flex items-center justify-between px-4 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] rounded-lg font-medium transition-colors"
                >
                  <span>Actualités</span>
                  <i className={`ri-arrow-${openMenu === 'actualites' ? 'up' : 'down'}-s-line text-xl`}></i>
                </button>
                {openMenu === 'actualites' && (
                  <div className="ml-4 mt-2 space-y-1">
                    <Link
                      to="/actualites/evenements"
                      onClick={() => setMobileMenuOpen(false)}
                      className="block px-4 py-2 text-gray-600 hover:text-[#14B8A6] transition-colors"
                    >
                      Événements
                    </Link>
                    <Link
                      to="/actualites/projets"
                      onClick={() => setMobileMenuOpen(false)}
                      className="block px-4 py-2 text-gray-600 hover:text-[#14B8A6] transition-colors"
                    >
                      Projets
                    </Link>
                    <Link
                      to="/actualites/galerie"
                      onClick={() => setMobileMenuOpen(false)}
                      className="block px-4 py-2 text-gray-600 hover:text-[#14B8A6] transition-colors"
                    >
                      Galerie
                    </Link>
                  </div>
                )}
              </div>

              
              <div>
                <button
                  onClick={() => toggleMobileSubmenu('outils')}
                  className="w-full flex items-center justify-between px-4 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] rounded-lg font-medium transition-colors"
                >
                  <span>Outils</span>
                  <i className={`ri-arrow-${openMenu === 'outils' ? 'up' : 'down'}-s-line text-xl`}></i>
                </button>
                {openMenu === 'outils' && (
                  <div className="ml-4 mt-2 space-y-1">
                    <Link
                      to="/outils/esidoc"
                      onClick={() => setMobileMenuOpen(false)}
                      className="block px-4 py-2 text-gray-600 hover:text-[#14B8A6] transition-colors"
                    >
                      Esidoc
                    </Link>
                    <Link
                      to="/outils/pronote"
                      onClick={() => setMobileMenuOpen(false)}
                      className="block px-4 py-2 text-gray-600 hover:text-[#14B8A6] transition-colors"
                    >
                      Pronote
                    </Link>
                  </div>
                )}
              </div>

              
              <Link
                to="/contact"
                onClick={() => setMobileMenuOpen(false)}
                className="block px-4 py-3 text-gray-700 hover:bg-[#14B8A6]/10 hover:text-[#14B8A6] rounded-lg font-medium transition-colors"
              >
                Contact
              </Link>

              
            </div>
          </div>
        </div>
      </nav> */}
    </div>
  );
}